(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/url-helper/assets/javascripts/url-helper.js') >= 0) return;  svs.modules.push('/components/marketplace/url-helper/assets/javascripts/url-helper.js');

'use strict';

const isServer = svs.isServer;
const trinidad = isServer ? require('@svenskaspelab/trinidad-core').core : {};
const urlMapping = isServer ? trinidad.urlMapping : svs.core.urlMapping;

const getMarketplaceTogetherUrlWithoutRoot = () => {
  const marketplaceTogetherUrl = urlMapping.get('marketplaceTogether');
  const marketplaceRootUrl = urlMapping.get('marketplace');
  return marketplaceTogetherUrl === null || marketplaceTogetherUrl === void 0 ? void 0 : marketplaceTogetherUrl.replace(marketplaceRootUrl, '');
};

const getMarketplaceRetailWithoutRoot = () => {
  const marketplaceRetailUrl = urlMapping.get('marketplaceRetail');
  const marketplaceRootUrl = urlMapping.get('marketplace');
  return marketplaceRetailUrl === null || marketplaceRetailUrl === void 0 ? void 0 : marketplaceRetailUrl.replace(marketplaceRootUrl, '');
};
const toExport = {
  getMarketplaceTogetherUrlWithoutRoot,
  getMarketplaceRetailWithoutRoot
};
if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.components.marketplace.urlHelper', toExport);
}

 })(window);